//@flow
import React from 'react';
import './styles.scss';
import type { VersionLevel } from 'types/product';

type Props = {
  level: Object<VersionLevel>,
  selectedLevelId: string,
  onClick: () => void,
};

export const ProductLevels = (props: Props) => {
  const { level, selectedLevelId, onClick } = props;
  return (
    <>
      <div
        onClick={e => onClick(level.id)}
        className={`levels-box ${selectedLevelId === level.id &&
          'active-level'}`}
      ></div>
    </>
  );
};
